import { render } from "./CompareOffer.vue?vue&type=template&id=11f47ef2"
import script from "./CompareOffer.vue?vue&type=script&lang=js"
export * from "./CompareOffer.vue?vue&type=script&lang=js"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__